import flatten from 'flat';
import tooltip from './tooltip.json';
import placeholder from './placeholder.json';
import contact from './contact.json';
import notice from './notice.json';
import shared from './shared.json';
import responder from './responder.json';
import dids from './dids.json';
import error from './error.json';
import inbox from './inbox.json';
import ticket from './ticket.json';
import menu from './menu.json';
import page404 from './404.json';
import feedback from './feedback.json';
import users from './users.json';
import domain from './domain.json';
import tendlc from './tendlc.json';
import tfn from './tfn.json';

export default {
  tfn: flatten(tfn, { delimiter: '_' }),
  tendlc: flatten(tendlc, {
    delimiter: '_',
  }),
  domain: flatten(domain, {
    delimiter: '_',
  }),
  users: flatten(users, {
    delimiter: '_',
  }),
  feedback: flatten(feedback, {
    delimiter: '_',
  }),
  page404: flatten(page404, {
    delimiter: '_',
  }),
  tooltip: flatten(tooltip, {
    delimiter: '_',
  }),
  placeholder: flatten(placeholder, {
    delimiter: '_',
  }),
  contact: flatten(contact, {
    delimiter: '_',
  }),
  notice: flatten(notice, {
    delimiter: '_',
  }),
  // common shared
  shared: flatten(shared, {
    delimiter: '_',
  }),
  responder: flatten(responder, {
    delimiter: '_',
  }),
  dids: flatten(dids, {
    delimiter: '_',
  }),
  error: flatten(error, {
    delimiter: '_',
  }),
  inbox: flatten(inbox, {
    delimiter: '_',
  }),
  ticket: flatten(ticket, {
    delimiter: '_',
  }),
  menu: flatten(menu, {
    delimiter: '_',
  }),
};
